<template>
  <a-modal :footer="false" :open="isOpen" @cancel="handleOk">
    <div class="py-5">Do you want to sign out?</div>
    <div class="flex justify-evenly gap-10">
      <SubmitButton @click="logout" :val="'Yes'" :loading="this.loading" />
      <SubmitButton
        @click="handleOk"
        class="bg-red-500"
        :val="'No'"
        :loading="false"
      />
    </div>
  </a-modal>
</template>

<script>
//services
import authService from "@/services/auth-service.js";

//libraries
import { useToast } from "vue-toastification";

//components
import SubmitButton from "@/components/UI/Inputs/FormSubmitInput.vue";

export default {
  name: "LogoutModal",
  props: ["isOpen", "handleOk"],
  components: {
    SubmitButton,
  },
  data() {
    return {
      loading: false,
      toast: useToast(),
    };
  },
  methods: {
    //requests
    async logout() {
      this.loading = true;
      this.$store.commit("setUserInfo", {});

      this.loading = false;
      this.handleOk();

      try {
        const result = await authService.logout();
        if (result) {
          this.toast.success("Successfully logged out", {
            timeout: 2000,
          });
        }
      } catch (err) {
        this.loading = false;
        const message = err?.response?.data?.message;
      }
      localStorage.clear();
      this.$router.push({
        name: "Login",
      });
    },
  },
};
</script>

<style></style>
